export default __webpack_public_path__ + "static/media/background-loop-melodic-techno-03-2691.f35b72f0.mp3";